import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { DocumentReportsModel } from 'common/models/page-models/reports/document-reports/document-report-data-model';
import { DocumentReportsListingModel } from 'common/models/page-models/reports/document-reports/document-report-grid-model';
import { GridResolver } from 'common/resolvers/core-resolvers/grid.resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { DocumentReportsWidgetService } from 'common/widget/reports/document-report-widget.service';
 
@Injectable({
    providedIn: 'root'
})
export class DocumentReportsResolver extends GridResolver<DocumentReportsModel, DocumentReportsListingModel> {
    constructor(
        protected fs: DocumentReportsWidgetService,
        protected override  router: Router,
        protected override  systemService: SystemService
    ) {
        super(fs, router, systemService);
    }

     override modifyResponseData(dataModel: any, meta: any, widget: any) {
        dataModel['filterData'] = new DocumentReportsModel();
        return dataModel;
    }
}